import { WebSocketSubject, WebSocketSubjectConfig } from 'rxjs/webSocket';
import { Subject } from 'rxjs/Subject';
import { MetricsService } from '../../../../shared/services/metrics.service';
import { MetricsType } from '../../../../shared/components/models/metrics/metrics-type.enum';
import { isNotNullOrUndefined } from 'codelyzer/util/isNotNullOrUndefined';

export class RxWebsocketSubject<T> extends Subject<T> {

  private wsSubjectConfig: WebSocketSubjectConfig<T>;
  private socket: WebSocketSubject<any>;

  constructor(
    private url: string,
    private metricsService: MetricsService,
  ) {
    super();

    this.wsSubjectConfig = {
      url: this.url,
      closeObserver: {
        next: (e: CloseEvent) => {
          this.socket = null;
        }
      },
      openObserver: {
        next: (e: Event) => {
        }
      }
    };
    // connect webSocket on create object
    this.connect();
  }

  connect(): void {
    try {
      this.socket = new WebSocketSubject(this.wsSubjectConfig);
      this.socket.subscribe(
        (m) => {
          this.next(m);
        },
        (error: Event) => {
          if (!this.socket) {
            this.reconnect();
          }
        }, () => {
          // called pm
        });
    } catch (error) {
      this.metricsService.sendSimpleMetric(
        'RxWebsocketSubject:connect:error',
        MetricsType.WEBSOCKET,
        JSON.stringify(error)
      );
    }
  }

  // disconnect WebSocket
  disconnect(): void {
    if (this.socket) {
      this.socket.unsubscribe();
    }
  }

  // WebSocket Reconnect handling
  reconnect(): void {
  }

  // sending the message
  send(data: any): void {
    if (isNotNullOrUndefined(this.socket)) {
      this.socket.next(data);
    }
  }
}
